"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNotification = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _uuid = require("uuid");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialNotification = {
  message: '',
  linkMessage: '',
  type: 'success',
  onClick: function onClick() {}
};
var useNotification = exports.useNotification = function useNotification() {
  var _useState = (0, _react.useState)(initialNotification),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    notification = _useState2[0],
    setNotification = _useState2[1];
  var showNotification = function showNotification(displayNotification) {
    setNotification(_objectSpread(_objectSpread({}, displayNotification), {}, {
      id: (0, _uuid.v4)()
    }));
  };
  return [notification, showNotification];
};